import entries from 'lodash/entries';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';

export const getQueryStringParams = (
  search = window.location.search,
  { parseValues = true } = {}
) => {
  if (!search || !isString(search)) {
    return {};
  }

  if (search.startsWith('?')) {
    search = search.substring(1);
  }

  return search.split('&').reduce((acc, keyValue) => {
    let key = keyValue.substring(0, keyValue.indexOf('='));
    let value = keyValue.substring(keyValue.indexOf('=') + 1);

    if (!key) {
      key = value;
      value = true;
    }

    if (parseValues) {
      try {
        value = JSON.parse(decodeURIComponent(value));
      } catch {
        // no catch
      }
    }

    acc[key] = value;
    return acc;
  }, {});
};

export const getQueryStringValueByKey = (
  key,
  search = window.location.search
) => {
  if (typeof key !== 'string') {
    return null;
  }

  const queryStringParams = getQueryStringParams(search, {
    parseValues: false,
  });

  return queryStringParams[key] || null;
};

export const formatQueryStringParams = (params = {}, prefix = '?') => {
  if (!isPlainObject(params)) throw new Error('Params must be an object');

  return entries(params).reduce(
    (acc, [key, value], i) =>
      acc + `${(i === 0 ? prefix : '&') + key}=${encodeURIComponent(value)}`,
    ''
  );
};

export const getApiEndpoint = () => {
  const uri = __NODE_API_BASE_URL__ || window.location.pathname;
  return uri.replace(new RegExp(`/+(?:${__BRAND__}(?:/+)?)?$`), '');
};

export const getQueryFromUrl = url => {
  const index = url.indexOf('?');

  if (index !== -1) {
    return url.substr(index);
  }

  return '';
};
